import React from 'react'
import './Press.css';
import { FaArrowLeft } from "react-icons/fa";
import { Link } from 'react-router-dom';
import press from '../Components/images/Indian_express.jpeg'

const Press = () => {
  return (
    <div className='add'>
    <div className="top-left-container">
      <Link to="/" className="top-left-btn">
        <FaArrowLeft />
      </Link>
    </div>
    <div className="advataise">
      <img src={press} alt='press' height={630} width={500}/>
    </div>  
  </div>
  )
}

export default Press;